<template>
  <v-container
    v-if="this.selectedAdvertiser.data"
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <h1>Linked Accounts</h1>
      </v-flex>
    </v-layout>
    <v-layout
      row
      align-center
    >
      <v-flex xs3>
        <v-subheader>Linked ad account:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <div class="body-1">{{ linkedAdAccount.name }}</div>
        <div class="body-2" v-if="linkedAdAccount.id">{{ linkedAdAccount.id.substr(4) }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      row
      align-center
    >
      <v-flex xs3>
        <v-subheader>Linked page:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <div class="body-1">{{ linkedPage.name }}</div>
        <div class="body-2">{{ linkedPage.id }}</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AdminLinkedAccounts',
  data () {
    return {}
  },
  props: {
    selectedAdvertiser: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    user () {
      return this.$store.getters.getCurrentUser
    },
    linkedAdAccount () {
      if (!this.selectedAdvertiser) return {}
      const id = this.selectedAdvertiser.data.ad_account
      return this.user.adAccounts.find(a => a.id === id) || {}
    },
    linkedPage () {
      if (!this.selectedAdvertiser) return {}
      const id = this.selectedAdvertiser.data.fb_page_id
      return this.user.accounts.find(a => a.id === id) || {}
    }
  }
}
</script>
